import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { LocationProvider } from './LocationContext'; // Import the LocationProvider
import { useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onDisconnect, set } from "firebase/database";
import { app } from './firebase.js';
import Login from './Pages/Login.js';
import Recoverpass from './Pages/Recoverpass.js';
import './App.css';
import './dash.css';
import './ResponsiveDash.css';
import './Respdesign.css';
import InstructorActivityTracker from './Components/InstructorActivityTracker.js';

// Instructor Accounts new
import DashboardIn from './Instructor/DashboardIn';
import MyCourses from './Instructor/MyCourses';
import Assignments from './Instructor/Assignments';
import Workspace from './Instructor/Workspace';
import Workshops from './Instructor/Workshops';
import ClientProjo from './Instructor/Clientprojects';
import Studentsreposts from './Instructor/Studentsreposts';
import MyThoughts from './Instructor/MyThoughts';
import AiAssistantIn from './Instructor/AiAssistant';
import ProfileIn from './Instructor/Profile';
import Updateaccount from './Instructor/Updateaccount';
import AllCalls from './Instructor/AllCalls';
import StudentProfile from './Instructor/StudentProfile';
import EditScheme from './Instructor/EditScheme';

function App() {

  const auth = getAuth();

  useEffect(() => {
    const db = getDatabase(app);
    // Listen for changes in authentication state
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const userId = user.uid;
        const userStatusRef = ref(db, `/status/${userId}`);

        // User is online
        const onlineStatus = {
          state: "online",
          last_changed: Date.now(),
          userId:userId
        };

        const offlineStatus = {
          state: "offline",
          last_changed: Date.now(),
          userId:userId
        };

        // Set user as online when connected
        set(userStatusRef, onlineStatus);

        // Set user as offline automatically when disconnected
        onDisconnect(userStatusRef).set(offlineStatus);
      }
    });
  }, [auth]);


  return (
    <div className="App">
      <LocationProvider>
          <BrowserRouter>
            <InstructorActivityTracker />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<Recoverpass />} />
              <Route path="/recover" element={<Recoverpass />} />

              {/* INSTRUCTOR ACCOUNT*/}
              <Route path="dashboard" element={<DashboardIn />} />
              <Route path="my-courses" element={<MyCourses />} />
              <Route path="assignments" element={<Assignments />} />
              <Route path="workspace" element={<Workspace />} />
              <Route path="workshops" element={<Workshops />} />
              <Route path="assigned-profects" element={<ClientProjo />} />
              <Route path="students-reports" element={<Studentsreposts />} />
              <Route path="my-thoughts" element={<MyThoughts />} />
              <Route path="ai-assistant" element={<AiAssistantIn />} />
              <Route path="profile" element={<ProfileIn />} />
              <Route path="edit-profile" element={<Updateaccount />} />
              <Route path="my-courses/:courseId/edit-scheme" element={<EditScheme />} />
              <Route path="student-profile/:studentId" element={<StudentProfile />} />
              <Route path="class-session" element={<AllCalls />} />
            </Routes>       
          </BrowserRouter>    
        </LocationProvider> 
    </div>
  );
}

export default App;
